// We only need to import the modules necessary for initial render
import CoreLayout from '../layouts/CoreLayout/CoreLayout'
import BoxLayout from '../layouts/BoxLayout/BoxLayout'
import Home from './Home'
import Login from './Home/routes/Login'
import PhoneValidation from './Home/routes/PhoneValidation'
import AdditionalInfo from './Home/routes/AdditionalInfo'
import CreatePassword from './Home/routes/CreatePassword'
import Dashboard from './Home/routes/Dashboard'
import AddressVerify from './Home/routes/AddressVerify'
import AddressVerifyApply from './Home/routes/AddressVerifyApply'
import ApartmentVerify from './Home/routes/ApartmentVerify'
import NewUsageContract from './Home/routes/NewUsageContract'
import NewConnContract from './Home/routes/NewConnContract'
import ConnContractStatus from './Home/routes/ConnContractStatus'
import ContractDetail from './Home/routes/ContractDetail'
import AllInvoices from './Home/routes/AllInvoices'
import UnreadMeterObjection from './Home/routes/UnreadMeterObjection'
import NewAppointment from './Home/routes/NewAppointment'
import CreateDocument from './Home/routes/CreateDocument'
import EnterpriseProfile from './Home/routes/Profile/Enterprise'
import IndividualProfile from './Home/routes/Profile/Individual'
// new contract negative pages
import ActiveContractExist from './Home/routes/ContractResults/ActiveContractExist'
import ConnPriceDebtExist from './Home/routes/ContractResults/ConnPriceDebtExist'
import ConnPriceDiffExistTenant from './Home/routes/ContractResults/ConnPriceDiffExistTenant'
import ConnPriceDiffExistHost from './Home/routes/ContractResults/ConnPriceDiffExistHost'
import Info from './Home/routes/ContractResults/Info'
// generic pages
import NotFound from './Home/routes/Error/NotFound'
import Forbidden from './Home/routes/Error/Forbidden'
import SessionEnd from './Home/routes/Error/SessionEnd'
import PaymentScreen from './Home/routes/Payment/PaymentScreen';
import PaymentMasterpassError from './Home/routes/Payment/PaymentMasterpassError'
import PaymentError from './Home/routes/Payment/PaymentError'
import PaymentSuccess from './Home/routes/Payment/PaymentSuccess'
import Appointment from './Home/routes/Appointment'
import AppointmentResult from './Home/routes/AppointmentResult'
import AppointmentList from './Home/routes/AppointmentList'
// import AppointmentNoLogin from './Home/routes/AppointmentNoLogin'

import PaymentScreenIBB from "./Home/routes/PaymentIBB/PaymentScreen";
import UploadDocument from './Home/routes/UploadDocument/UploadDocumentScreen';
import PaySomeOneElseView from './Home/routes/PaySomeOneElse';
import History from './Home/routes/PaySomeOneElseHistory';
import EmailConfirm from './Home/routes/EmailConfirm'
import LoginIS from './Home/routes/LoginIS'

/*  Note: Instead of using JSX, we recommend using react-router
    PlainRoute objects to build route definitions.   */
export const createRoutes = (store) => (
  [
    {
        path        : '/',
        component   : CoreLayout,
        indexRoute  : Login(store),
    },
    {
      path          : '/login',
      component     : CoreLayout,
      indexRoute    : Login(store),
    },
    {
      path          : '/error/session_end',
      component     : CoreLayout,
      indexRoute    : SessionEnd(store),
    },
    {
      path          : '/phone/validation',
      component     : BoxLayout,
      indexRoute    : PhoneValidation(store),
    },
    {
      path          : '/additional_info',
      component     : BoxLayout,
      indexRoute    : AdditionalInfo(store),
    },
    {
      path          : '/password/create',
      component     : BoxLayout,
      indexRoute    : CreatePassword(store),
    },
    {
      path          : '/dashboard',
      component     : CoreLayout,
      indexRoute    : Dashboard(store),
    },
    {
      path          : '/contract/address/verify',
      component     : CoreLayout,
      indexRoute    : AddressVerify(store),
    },
    {
      path          : '/contract/address/verify/apply',
      component     : CoreLayout,
      indexRoute    : AddressVerifyApply(store),
    },
    {
      path          : '/contract/apartment/verify',
      component     : CoreLayout,
      indexRoute    : ApartmentVerify(store),
    },
    {
      path          : '/contract/new/usage',
      component     : CoreLayout,
      indexRoute    : NewUsageContract(store),
    },
    {
      path          : '/contract/new/conn',
      component     : CoreLayout,
      indexRoute    : NewConnContract(store),
    },
    {
      path          : '/contract/status/conn',
      component     : CoreLayout,
      indexRoute    : ConnContractStatus(store),
    },
    {
      path          : '/contract/detail',
      component     : CoreLayout,
      indexRoute    : ContractDetail(store),
    },

    {
      path          : '/all_invoices',
      component     : CoreLayout,
      indexRoute    : AllInvoices(store),
    },

    {
      path          : '/invoice/unread_meter',
      component     : CoreLayout,
      indexRoute    : UnreadMeterObjection(store),
    },
    {
      path          : '/contract/new/appointment',
      component     : CoreLayout,
      indexRoute    : NewAppointment(store),
    },
    {
      path          : '/contract/create/document',
      component     : CoreLayout,
      indexRoute    : CreateDocument(store),
    },
    {
      path          : '/contract/result/active',
      component     : CoreLayout,
      indexRoute    : ActiveContractExist(store),
    },
    {
      path          : '/contract/result/info',
      component     : CoreLayout,
      indexRoute    : Info(store),
    },
    {
      path          : '/contract/result/debt',
      component     : CoreLayout,
      indexRoute    : ConnPriceDebtExist(store),
    },
    {
      path          : '/contract/result/diff_t',
      component     : CoreLayout,
      indexRoute    : ConnPriceDiffExistTenant(store),
    },
    {
      path          : '/contract/result/diff_h',
      component     : CoreLayout,
      indexRoute    : ConnPriceDiffExistHost(store),
    },
    {
      path          : '/payment',
      component     : CoreLayout,
      indexRoute    : PaymentScreen(store),
    },
    {
      path          : '/payment/error',
      component     : CoreLayout,
      indexRoute    : PaymentError(store),
    },
    {
      path          : '/payment/mperror',
      component     : CoreLayout,
      indexRoute    : PaymentMasterpassError(store)
    },
    
    {
      path          : '/payment/success',
      component     : CoreLayout,
      indexRoute    : PaymentSuccess(store),
    },
    // {
    //   path          : '/online_appointment',
    //   component     : CoreLayout,
    //   indexRoute    : AppointmentNoLogin(store),
    // },
    {
      path          : '/appointment',
      component     : CoreLayout,
      indexRoute    : Appointment(store),
    },
    {
      path          : '/appointment_result',
      component     : CoreLayout,
      indexRoute    : AppointmentResult(store),
    },
    {
      path          : '/myappointment',
      component     : CoreLayout,
      indexRoute    : AppointmentList(store),
    },
    {
      path          : '/error/forbidden',
      component     : CoreLayout,
      indexRoute    : Forbidden(store),
    },
    {
      path          : '/profile/enterprise',
      component     : CoreLayout,
      indexRoute    : EnterpriseProfile(store),
    },
    {
      path          : '/profile/individual',
      component     : CoreLayout,
      indexRoute    : IndividualProfile(store),
    },
    {
      path          : '/ibpayment',
      component     : CoreLayout,
      indexRoute    : PaymentScreenIBB(store),
    },
    {
      path          : '/uploaddocument',
      component     : CoreLayout,
      indexRoute    : UploadDocument(store),
    },
    {
      path          : '/paysomeoneelse',
      component     : CoreLayout,
      indexRoute    : PaySomeOneElseView(store),
    },
    {
      path          : '/paysomeoneelse/history',
      component     : CoreLayout,
      indexRoute    : History(store),
    },
    {
      path          : '/emailconfirmation',
      component     : CoreLayout,
      indexRoute    : EmailConfirm(store),
    },
    {
      path          : '/loginis',
      component     : CoreLayout,
      indexRoute    : LoginIS(store),
    },
    {
      path          : '*',
      component     : CoreLayout,
      indexRoute    : NotFound(store),
    },
    
  ]
)

/*  Note: childRoutes can be chunked or otherwise loaded programmatically
    using getChildRoutes with the following signature:

    getChildRoutes (location, cb) {
      require.ensure([], (require) => {
        cb(null, [
          // Remove imports!
          require('./Counter').default(store)
        ])
      })
    }

    However, this is not necessary for code-splitting! It simply provides
    an API for async route definitions. Your code splitting should occur
    inside the route `getComponent` function, since it is only invoked
    when the route exists and matches.
*/

export default createRoutes



// WEBPACK FOOTER //
// ./src/routes/index.js